function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getEnvironment } from '@sail/utils';
export const REQUEST_MARKER_HEADER = 'Wrmkch-ky';
export const REQUEST_MARKER_VALUE = 'wrmkch-value';
export const REQUEST_QUERY_PARAM = 'Wrmkcp-ky';
export const REQUEST_QUERY_PARAM_VALUE = 'wrmkcp-value';
const sampleRate = 0.1 / 100; // 0.1% chance to add markers
export function shouldAddMarkers() {
    if (getEnvironment() === 'test') {
        // In test environments, we never add markers
        return false;
    }
    // Random sample condition to determine if markers should be added.
    if (Math.random() < sampleRate) {
        return true;
    }
    return false;
}
export function parseUrl(url) {
    try {
        return new URL(url);
    } catch (error) {
        return undefined;
    }
}
function addQueryParamMarkerToUrl(url) {
    const u = parseUrl(url);
    if (!u) {
        return url;
    }
    if (u.searchParams.size > 0) {
        // If there are existing search params, we add the marker as a new param
        u.searchParams.set(REQUEST_QUERY_PARAM, REQUEST_QUERY_PARAM_VALUE);
    }
    return u.toString();
}
/**
 * Adds the request markers
 * NOTE: This is only exported for tests. Use `maybeAddRequestMarkers` in production code instead.
 */ export function _addRequestMarkers(url, headers, handleQueryParams) {
    return {
        headers: _object_spread_props(_object_spread({}, headers), {
            // Always add the marker header
            [REQUEST_MARKER_HEADER]: REQUEST_MARKER_VALUE
        }),
        url: handleQueryParams ? addQueryParamMarkerToUrl(url) : url
    };
}
/**
 * Adds the request markers
 */ export function maybeAddRequestMarkers(url, headers, { handleQueryParams } = {}) {
    try {
        if (shouldAddMarkers()) {
            return _addRequestMarkers(url, headers, handleQueryParams);
        }
    } catch (error) {
    // we don't really care about errors here, just return the original url and headers
    }
    return {
        headers,
        url
    };
}

//# sourceMappingURL=index.js.map